// extracted by mini-css-extract-plugin
export default {"data_table":"DataTable_data_table__jbSBS"};